import React from 'react';
import { string, shape } from 'prop-types';
import styled, { css } from 'styled-components';
import { getSansRegular } from '@bbc/psammead-styles/font-styles';
import { GEL_SPACING } from '@bbc/gel-foundations/spacings';
import { C_METAL, C_SHADOW } from '@bbc/psammead-styles/colours';
import { GEL_LONG_PRIMER } from '@bbc/gel-foundations/typography';
var AVATAR_DIAMETER = '4rem';
var Container = /*#__PURE__*/styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-1dejso6-0"
})(["align-items:center;display:flex;", ""], function (_ref) {
  var avatar = _ref.avatar;
  return avatar && css(["margin-right:-", ";margin-left:-", ";"], GEL_SPACING, GEL_SPACING);
});
var Avatar = /*#__PURE__*/styled.img.withConfig({
  displayName: "Avatar",
  componentId: "sc-1dejso6-1"
})(["border-radius:50%;height:", ";margin-right:", ";margin-left:", ";width:", ";"], AVATAR_DIAMETER, GEL_SPACING, GEL_SPACING, AVATAR_DIAMETER);
var Person = /*#__PURE__*/styled.ul.withConfig({
  displayName: "Person",
  componentId: "sc-1dejso6-2"
})(["list-style:none;margin-top:0;margin-bottom:0;padding-right:0;padding-left:0;", " ", ""], function (_ref2) {
  var service = _ref2.service;
  return getSansRegular(service);
}, GEL_LONG_PRIMER);
var Name = /*#__PURE__*/styled.li.withConfig({
  displayName: "Name",
  componentId: "sc-1dejso6-3"
})(["color:", ";"], C_SHADOW);
var Title = /*#__PURE__*/styled.li.withConfig({
  displayName: "Title",
  componentId: "sc-1dejso6-4"
})(["color:", ";"], C_METAL);

var Byline = function Byline(_ref3) {
  var service = _ref3.service,
      name = _ref3.name,
      title = _ref3.title,
      avatar = _ref3.avatar;
  return /*#__PURE__*/React.createElement(Container, {
    avatar: avatar
  }, avatar && /*#__PURE__*/React.createElement(Avatar, {
    src: avatar.src,
    alt: avatar.alt || ''
  }), /*#__PURE__*/React.createElement(Person, {
    role: "list",
    service: service
  }, /*#__PURE__*/React.createElement(Name, {
    role: "listitem",
    avatar: avatar
  }, name), /*#__PURE__*/React.createElement(Title, {
    role: "listitem"
  }, title)));
};

Byline.defaultProps = {
  avatar: null
};
Byline.propTypes = {
  service: string.isRequired,
  avatar: shape({
    src: string.isRequired,
    alt: string
  }),
  name: string.isRequired,
  title: string.isRequired
};
export default Byline;